var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTestId } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { FlatList, View } from 'react-native';
import { UploadContainer } from './components/upload-container';
import { UploadSingleFile } from './components/upload-single-file';
export var UploadFileWidgetComponent = props => {
  var testID = props.testID,
    _props$uploadContaine = props.uploadContainer,
    uploadContainer = _props$uploadContaine === void 0 ? {} : _props$uploadContaine,
    _props$uploadedFiles = props.uploadedFiles,
    uploadedFiles = _props$uploadedFiles === void 0 ? [] : _props$uploadedFiles,
    onUserAction = props.onUserAction,
    allowFileUploadOnWeb = props.allowFileUploadOnWeb,
    _props$hideOnUpload = props.hideOnUpload,
    hideOnUpload = _props$hideOnUpload === void 0 ? false : _props$hideOnUpload,
    uploadContainerAlignment = props.uploadContainerAlignment,
    restProps = __rest(props, ["testID", "uploadContainer", "uploadedFiles", "onUserAction", "allowFileUploadOnWeb", "hideOnUpload", "uploadContainerAlignment"]);
  var _useState = useState(true),
    isUploadContainerVisible = _useState[0],
    setUploadContainerVisible = _useState[1];
  var handleUserAction = function handleUserAction() {
    if (hideOnUpload) {
      setUploadContainerVisible(false);
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    args && onUserAction(...args);
  };
  var handleDeleteAction = (item, title) => {
    var _a;
    if (hideOnUpload) {
      setUploadContainerVisible(true);
    }
    (_a = item === null || item === void 0 ? void 0 : item.handleDeletePress) === null || _a === void 0 ? void 0 : _a.call(item, title);
  };
  var _handleActionCtaPress = (item, title) => {
    var _a;
    if (hideOnUpload) {
      setUploadContainerVisible(true);
    }
    (_a = item === null || item === void 0 ? void 0 : item.handleActionCtaPress) === null || _a === void 0 ? void 0 : _a.call(item, title);
  };
  useEffect(() => {
    setUploadContainerVisible(!hideOnUpload);
  }, [hideOnUpload]);
  return _jsxs(View, Object.assign({}, restProps, getTestId(testID), {
    children: [isUploadContainerVisible && _jsx(UploadContainer, Object.assign({}, uploadContainer, {
      allowFileUploadOnWeb: allowFileUploadOnWeb,
      onUserAction: handleUserAction,
      uploadContainerAlignment: uploadContainerAlignment
    })), _jsx(FlatList, {
      data: uploadedFiles,
      keyboardShouldPersistTaps: "handled",
      renderItem: _ref => {
        var item = _ref.item,
          index = _ref.index;
        return _jsx(UploadSingleFile, Object.assign({}, item, {
          onUserAction: handleUserAction,
          handleDeletePress: title => handleDeleteAction(item, title),
          handleActionCtaPress: title => _handleActionCtaPress === null || _handleActionCtaPress === void 0 ? void 0 : _handleActionCtaPress(item, title)
        }), "upload_file_" + index);
      },
      keyExtractor: (_, index) => "upload_file_" + index
    })]
  }));
};
UploadFileWidgetComponent.genericRendererKey = 'AirUploadFileWidget';